export default {
    "fr": {
        "Address": "Adresse",
        "City": "Ville",
        "Company": "Nom",
        "Country": "Pays",
        "Create account": "Créer le compte",
        "Update account": "Modifier le compte",
        "Email": "Email",
        "Firstname": "Prénom",
        "Login": "Identifiant",
        "Lastname": "Nom",
        "Message": "Message",
        "Password": "Mot de passe",
        "Phone": "Téléphone",
        "Save": "Enregistrer",
        "Update": "Mettre à jour",
        "Subject": "Objet",
        "Zipcode": "Code postal",
        "Type to search": "Rechercher ...",
        "Cancel": "Annuler",
        "Today": "Aujourd'hui"
    },
    "en": {
        "Address": "Adress",
        "City": "City",
        "Company": "Company",
        "Country": "Country",
        "Create account": "Create account",
        "Update account": "Update account",
        "Email": "Email",
        "Firstname": "Firstname",
        "Login": "Login ID",
        "Lastname": "Lastname",
        "Message": "Message",
        "Password": "Password",
        "Phone": "Phone",
        "Save": "Save",
        "Update": "Update",
        "Subject": "Object Internship request",
        "Zipcode": "Zipcode",
        "Type to search": "Type to search ...",
        "Cancel": "Cancel",
        "Today": "Today"
    }
}
